<template>
	<div>
		<table class="list">
			<thead>
				<tr class="list__head">
					<th class="list__head__title" colspan="1">{{ $t('WEBAPP_RANK') }}</th>
					<th class="list__head__title" colspan="1">{{ $t('WEBAPP_TITLE', { NUMBER: null }) }}</th>
					<th class="list__head__title offers top-rank" colspan="1">{{ $t('WEBAPP_HIGHEST_RANK') }}</th>
					<th class="list__head__title offers" colspan="1">{{ $t('WEBAPP_STREAMING') }}</th>
					<th class="list__head__title" colspan="1"></th>
				</tr>
			</thead>
			<StreamingChartsListItem v-for="(title, index) in titles" :key="index" :title="title" :index="index" />
		</table>
		<p class="timestamp">
			<i18n-t keypath="WEBAPP_STREAMING_CHART_TIMESTAMP" tag="span">
				<template #timestamp>
					<NuxtTime
						v-if="lastUpdated"
						:datetime="lastUpdated"
						:locale="dateTimeLocale"
						time-zone="UTC"
						hour="2-digit"
						minute="2-digit"
						hour-cycle="h23"
					/>{{ ', ' }}<NuxtTime
						v-if="lastUpdated"
						:datetime="lastUpdated"
						:locale="dateTimeLocale"
						time-zone="UTC"
						year="numeric"
						month="2-digit"
						day="2-digit"
					/>
				</template>
			</i18n-t>
		</p>
	</div>
</template>

<script setup lang="ts">
import type { StreamingChartTitle } from './types';

import StreamingChartsListItem from '@/components/streaming-charts/StreamingChartsListItem.vue';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

interface StreamingChartsListProps {
	titles: StreamingChartTitle[];
	totalTitles: number | undefined;
	lastUpdated?: string;
}
withDefaults(defineProps<StreamingChartsListProps>(), {});

const { country, language } = storeToRefs(useLanguageStore());

const dateTimeLocale = computed(() => new Intl.Locale(language.value.split('-')[0], { region: country.value }).baseName);
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.list {
	width: 100%;
	border-spacing: 0;

	&__head {
		&__title {
			text-align: left;
			color: #c6c8cd;
			font-size: 16px;
			font-weight: 400;
			letter-spacing: 0.24px;
			border-bottom: 1px solid #1c252f;
			padding-bottom: 8px;
		}
	}
}

.offers {
	@media (max-width: 700px) {
		display: none;
	}
}

.top-rank {
	text-align: center;
}
</style>
